export default "__VITE_ASSET__yOnQKwRl__"